import { authentication } from '@/auth/authentication';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/css/app.css';
import BackToTop from 'vue-backtotop';
import { store } from './store';
import { firebaseListener } from './firestoreConfig';
import VueGtag from "vue-gtag";

const feather = require('feather-icons');
feather.replace();

const toCurrency = function (value) {
	let eur = new Intl.NumberFormat('nl-BE', {
		style: 'currency',
		currency: 'EUR',
	});
	return eur.format(value);
}
const vueFilters = {
	toCurrency
}
authentication();

firebaseListener(authStatusChange);
store.dispatch('getSponsors');


const storeApp = createApp(App)
storeApp.use(store)
	.use(router)
	.use(BackToTop)
	.use(VueGtag, {
		appName: 'Ouderraad Loppem Shop',
		pageTrackerScreenViewEnabled: true,
		config: { id: "G-BR3VYJDKED" }
	});
storeApp.config.globalProperties.$filters = vueFilters;
storeApp.mount('#app');



function authStatusChange(loggedIn, user) {
	if (store) {
		store.commit('AUTH_STATUS_CHANGE');
		if (user) {
			store.dispatch('getShoppingCart', {uid: user.uid, currentCart: store.getters.cartItemList});
		}
	}
}


const appTheme = localStorage.getItem('theme');

// Check what is the active theme and change theme when user clicks on the theme button in header.
if (
	appTheme === 'dark' &&
	document.querySelector('body').classList.contains('app-theme')
) {
	document.querySelector('body').classList.add('bg-primary-dark');
} else {
	document.querySelector('body').classList.add('bg-secondary-light');
}